module.exports = __webpack_public_path__ + "static/portfolio-mas-3-51fe495c5c4c53f2299c5ada19b98900.jpg";